import { expVal } from '@atlassian/jira-feature-experiments';
import { UNLICENSED } from '@atlassian/jira-shared-types/src/edition.tsx';
import { useAppEditions } from '@atlassian/jira-tenant-context-controller/src/components/app-editions/index.tsx';

const useShouldShowImporter = () => {
	const { core, software } = useAppEditions();

	return core !== UNLICENSED || software !== UNLICENSED;
};

export const useIsImportersOnProjectDirectoryEnabled = () => {
	return (
		useShouldShowImporter() &&
		expVal('importer_discovery_projects_directory_cta', 'isEnabled', false)
	);
};
